<template>
  <div>
    <Navigation />
    <div class="row tableUsers">
      <div v-if="addNewBrand" class="popUp-overlay"></div>
      <div v-show="addNewBrand" class="popUp-dialog zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <div class="col-sm-12">
                      <label class="floatLeft" for="form_name"
                        >Brand Name:</label
                      >
                      <input
                        v-model="brand_name"
                        id="brand_name"
                        type="text"
                        name="brand_name"
                        class="form-control"
                        placeholder
                        required="required"
                        data-error="error"
                        v-on:keyup="
                          resetMsg();
                          brandNameMsg = '';
                        "
                      />
                      <label v-if="brandNameMsg" class="floatLeft error-infobox"
                        >Please enter brand name.</label
                      >
                    </div>

                    <div class="col-sm-12">
                      <div class="floatLeft col-sm-9 p-0">
                        <label class="floatLeft mt-2" for="greenpoints"
                          >Points for default package:</label
                        >
                      </div>
                      <div class="col-sm-3 p-0">
                        <input
                          id="greenpoints"
                          v-model="defaultPoints"
                          type="number"
                          name="greenpoints"
                          class="form-control"
                          placeholder
                          required="required"
                          data-error="error"
                          v-on:change="
                            resetMsg();
                            pointsMsg = '';
                          "
                        />
                      </div>

                      <label v-if="pointsMsg" class="floatLeft error-infobox"
                        >Points should be greater than 0</label
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    @click.prevent="
                      addBrand();
                      resetMsg();
                    "
                    type="submit"
                    class="btn btnDark btn-success btn-send pointer"
                    value="Submit"
                  />
                  <input
                    v-on:click="addNewBrand = false"
                    type="cancel"
                    class="btn btn-secondary pointer button-width-helper"
                    value="Cancel"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-if="editBrand" class="popUp-overlay"></div>
      <div v-show="editBrand" class="popUp-dialog zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="edit_brand_name"
                      >Brand Name</label
                    >
                    <input
                      id="edit_brand_name"
                      v-model="edit_brand_name"
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                      value
                    />
                    <input type="hidden" v-model="edit_brand_id" value />
                    <label v-if="errorMsg" class="floatLeft error-infobox">{{
                      errorMsg
                    }}</label>
                  </div>
                </div>
              </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    @click.prevent="updateBrand()"
                    type="submit"
                    class="btn btnDark btn-success btn-send pointer"
                    value="Submit"
                  />
                  <input
                    v-on:click="editBrand = false"
                    type="cancel"
                    class="btn btn-secondary pointer button-width-helper"
                    value="Cancel"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-if="deleteBrand" class="popUp-overlay"></div>
      <div v-show="deleteBrand" class="popUp-dialog zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="delete_brand_id"
                      >Are you sure you want to delete this Brand?</label
                    >
                    <input
                      type="hidden"
                      v-model="delete_brand_id"
                      name="delete_brand_id"
                      value
                    />
                    <label v-if="errorMsg" class="floatLeft error-infobox">{{
                      errorMsg
                    }}</label>
                  </div>
                </div>
              </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    @click.prevent="confirmDelete()"
                    type="submit"
                    class="btn danger btnDark btn-success btn-send pointer"
                    value="Yes"
                  />
                  <input
                    v-on:click="deleteBrand = false"
                    type="cancel"
                    class="btn btnDark btn-success pointer"
                    value="No"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="toolbar">
              <!-- Here you can write extra buttons/actions for the toolbar -->
            </div>
            <div
              id="datatable_wrapper"
              class="dataTables_wrapper dt-bootstrap4"
            >
              <div class="row">
                <div class="col-sm-12 col-md-2 tableName">
                  <a
                    href="#"
                    class="btn btn-round btn-icon btn-sm createNew mt-1"
                    title="Add new brand"
                    v-on:click="addNew()"
                  >
                    <i class="fas fa-plus"></i>
                  </a>
                  <div>Brands</div>
                </div>
                <div class="col-sm-12 col-md-7"></div>
                <div class="col-sm-12 col-md-3">
                  <div id="datatable_filter" class="dataTables_filter mt-3">
                    <form
                      class="form-inline md-form floatRight searchDiv form-sm active-darkGreen-2 mt-2"
                    >
                      <input
                        class="form-control borderNone form-control-sm mr-3"
                        v-model="search"
                        v-on:keyup="filterResults()"
                        type="text"
                        placeholder="Search"
                        aria-label="Search"
                      />
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </form>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 min-table-height">
                  <table
                    id="datatable"
                    class="table table-striped table-bordered dataTable dtr-inline"
                    cellspacing="0"
                    width="100%"
                    role="grid"
                    aria-describedby="datatable_info"
                    style="width: 100%"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          class="sorting_asc"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-sort="ascending"
                          aria-label="Name: activate to sort column descending"
                          v-on:click="sortResults(1)"
                        >
                          Brand Name
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Age: activate to sort column ascending"
                          v-on:click="sortResults(2)"
                        >
                          Brand code
                        </th>
                        <!--    <th class="sorting" tabindex="0" aria-controls="datatable" rowspan="1" colspan="1" style="width: 229px;" aria-label="Age: activate to sort column ascending">Created on</th> -->
                        <th
                          class="disabled-sorting text-right sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 230px"
                          aria-label="Actions: activate to sort column ascending"
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-bind:key="index"
                        role="row"
                        v-for="(item, index) in items"
                        v-bind:class="[
                          index % 2 == 0 || index == 0 ? 'even' : 'odd',
                        ]"
                      >
                        <td tabindex="0" class="sorting_1">{{ item.name }}</td>
                        <td>{{ item.code }}</td>
                        <!--      <td>{{ brand.syncmodifiedon }}</td> -->
                        <td class="text-right">
                          <div class="actions_on_user">
                            <a
                              href="#"
                              class="btn btn-round btn-edit btn-icon btn-sm edit"
                              v-on:click="edit(item.id)"
                              id="edit"
                            >
                              <i class="far fa-edit"></i>
                            </a>
                            <label class="activity_label" for="edit"
                              >Edit</label
                            >
                          </div>
                          <div class="actions_on_user">
                            <a
                              href="#"
                              class="btn btn-round btn-danger btn-icon btn-sm remove"
                              v-on:click="del(item.id)"
                              id="delete"
                            >
                              <i class="fas fa-times"></i>
                            </a>
                            <label class="activity_label" for="delete"
                              >Delete</label
                            >
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <pagination
                :meta_data="meta_data"
                v-on:next="fetchResults"
              ></pagination>
            </div>
          </div>
          <!-- end content-->
        </div>
        <!--  end card  -->
      </div>
      <!-- end col-md-12 -->
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Navigation from "@/views/Navigation.vue";
import Pagination from "@/components/Pagination.vue";
import store from "./../store/index";
export default {
  components: {
    Navigation,
    Pagination,
  },
  data() {
    return {
      addNewBrand: false,
      editBrand: false,
      deleteBrand: false,
      brand_name: '',
      defaultPoints: 0,
      dir: 0,
      sort: null,
      order: null,
      brandNameMsg: '',
      pointsMsg: '',
      edit_brand_name: '',
      edit_brand_id: '',
      delete_brand_id: '',
      brand_id: null,
      errorMsg: '',
      successMsg: '',
      items: [],
      search: null,
      id: null,
      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        perpage: 5,
        total: 0,
      },
    };
  },
  mounted() {
    this.fetchResults();
  },
  methods: {
    addNew() {
      this.$data.addNewBrand = true;
      this.errorMsg = '';
    },
    edit(id) {
      this.edit_brand_name = this.edit_brand_id = this.errorMsg = '';
      axios
        .get(store.state.BASE_URI + 'admin/brands/fetch_brand', {
          headers: { Authorization: localStorage.getItem('accessToken') },
          params: {
            id,
          },
        })
        .then((res) => {
          this.edit_brand_name = res.data.brand.name;
          this.edit_brand_id = res.data.brand.id;
        });
      this.$data.editBrand = true;
    },
    del(id) {
      this.delete_brand_id = this.errorMsg = '';
      this.delete_brand_id = id;

      this.$data.deleteBrand = true;
    },
    confirmDelete() {
      axios
        .delete(
          store.state.BASE_URI + 'admin/brands/brand/' + this.delete_brand_id,
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        .then((res) => {
          this.fetchResults(
            this.meta_data.current_page,
            this.meta_data.perpage
          );
          this.$toasted
            .show(res.data.message, { type: 'success' })
            .goAway(2000);
          this.deleteBrand = false;
          //   this.edit_brand_name = res.data.brand.name;
          //   this.edit_brand_id = res.data.brand.id;
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
            this.$toasted.show(this.errorMsg, { type: 'error' }).goAway(2000);
          }
        });
    },
    closeAddBrand() {
      this.addNewBrand = false;
      this.brand_name = '';
      this.errorMsg = '';
      this.successMsg = '';
      this.defaultPoints = 0;
      this.brandNameMsg = '';
      this.pointsMsg = '';
    },
    validateForm() {
      if (!this.brand_name && this.defaultPoints == 0) {
        this.brandNameMsg = 'Please enter brand name';
        this.pointsMsg = 'Points should be greater than 0';
      } else if (this.brand_name && this.defaultPoints == 0) {
        this.brandNameMsg = '';
        this.pointsMsg = 'Points should be greater than 0';
      } else if (!this.brand_name && this.defaultPoints > 0) {
        this.brandNameMsg = 'Please enter brand name';
        this.pointsMsg = '';
      } else {
        this.brandNameMsg = '';
        this.pointsMsg = '';
      }
    },
    addBrand() {
      this.validateForm();
      axios.defaults.headers.common['Authorization'] = localStorage.getItem(
        'accessToken'
      );

      axios
        .post(store.state.BASE_URI + 'admin/brands/create', {
          params: {
            name: this.brand_name,
            default_points: this.defaultPoints,
          },
        })
        .then((response) => {
          this.fetchResults();
          this.successMsg = response.data.message;
          this.$toasted
            .show(response.data.message, { type: 'success' })
            .goAway(2000);
          this.closeAddBrand();
          //  setTimeout(() => {
          //    this.closeAddBrand();
          //  }, 3000);
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
            this.$toasted.show(this.errorMsg, { type: 'error' }).goAway(2000);
          }
        });
    },
    updateBrand() {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem(
        'accessToken'
      );
      axios
        .post(store.state.BASE_URI + 'admin/brands/edit_brand', {
          params: {
            name: this.edit_brand_name,
            id: this.edit_brand_id,
          },
          headers: {
            'Content-Type': 'text/plain;charset=utf-8',
          },
        })
        .then((response) => {
          this.fetchResults(this.meta_data.current_page);
          this.editBrand = false;
          this.$toasted
            .show(response.data.message, { type: 'success' })
            .goAway(2000);
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
            this.$toasted.show(this.errorMsg, { type: 'error' }).goAway(2000);
          }
        });
    },
    fetchResults(
      page = this.meta_data.current_page,
      perpage = this.meta_data.perpage,
      search = this.search,
      order = this.order,
      sort = this.sort,
      total = this.meta_data.total
    ) {
      axios
        .get(store.state.BASE_URI + 'admin/brands/load_brands', {
          headers: { Authorization: localStorage.getItem('accessToken') },
          params: {
            page,
            perpage,
            search,
            order,
            sort,
            total,
          },
        })
        .then((res) => {
          this.items = res.data.results.items;
          var pagination = res.data.results.pagination;
          this.meta_data.last_page = pagination.last_page;
          this.meta_data.current_page = pagination.current_page;
          this.meta_data.prev_page_url = pagination.prev_page_url;
          this.meta_data.perpage = pagination.perpage;
          this.meta_data.search = pagination.search;
          this.meta_data.total = pagination.total;
        });
    },
    filterResults() {
      this.meta_data.current_page = 1;
      this.fetchResults(
        this.meta_data.current_page,
        this.meta_data.perpage,
        this.search
      );
    },
    resetMsg() {
      this.errorMsg = '';
      this.successMsg = '';
    },
    sortResults(order) {
      this.dir++;
      this.order = order;

      if (this.dir % 2 == 0) this.sort = 'desc';
      else this.sort = 'asc';
      this.fetchResults(
        this.meta_data.current_page,
        this.meta_data.perpage,
        this.search,
        this.order,
        this.sort
      );
    },
  },
};
</script>

<style src="../css/style.css"></style>
